// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timesheetcont{
    background-color: white;
    border-radius: 5px;
}

.tsbods{
    font-family: "Inter";
    font-size: 16px;
    font-weight: 700;
    line-height: 19.36px;
    letter-spacing: 0.02em;
    text-align: left;
    color:#0079E9;
}
.tsheads{
    font-family:"Inter";
    font-size: 16px;
    font-weight: 600;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    text-align: left;
    color:#002C5D
}
.timesheetbuttontophead{
    background-color: #E5F0FC !important
}
.avlsickleave{
    height:55px;
    background-color: #E5F0FC !important;
    display: flex !important;
    gap: 10px ;
    white-space: nowrap;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    text-transform: capitalize !important;
}
.avlPTO{
    height:55px;
    background-color: #E5F0FC !important;
    display: flex !important;
    gap: 10px !important;
    white-space: nowrap;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    text-transform: capitalize !important;

}
.UTILIZEDSICK{
    height:55px;
    background-color: #E5F0FC !important;
    display: flex !important;
    gap: 10px !important;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    text-transform: capitalize !important;
}
.utilizedpo{
    height:55px;
    background-color: #E5F0FC !important;
    display: flex !important;
    gap: 10px !important;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    text-transform: capitalize !important;
}
.buttonleft{
    font-family: "Inter";
    font-size: 17px !important;
    font-weight: 700 !important;
    line-height: 19.36px;
    letter-spacing: 0.01em;
    text-align: left;
    color:#0056B2;
    white-space: nowrap
}
.buttonright{
    font-family: "Inter";
    font-size: 25px;
    font-weight: 700;
    line-height: 41.15px;
    letter-spacing: 0.02em;
    text-align: left;
    color:#0056B2
}
.timesheet-table {
    border-collapse: collapse;
    width: 100%;
}  
.timesheet-table th, .timesheet-table td {
    border: 1px solid #E9E9E9;
}
.modalname{
    font-family: "Inter";
    font-size: 18px;
    font-weight: 700;
    line-height: 21.78px;
    letter-spacing: 0.02em;
    text-align: left;
    color:#0070E9;
    white-space:nowrap
}
.timesheet-input {
    width: 96%;
    height: 50px;
    border: none;
}
.daystyle{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    text-align: center;
    color:#00162E
}
.projectntaskname{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    text-align: center;
    color:"#00162E";
    padding: 10px;
    /* width:100%; */
    min-width:100px ;
    height: 70px;
}
.datebutton{
    background-color: #008A27 !important;
    font-family: "Inter" !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 16.94px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    height: 40px !important;
    color:white !important;
    width:100% !important;
    max-width: 157px !important;
    gap:10px;
    text-transform: capitalize !important;
    align-items: center;
 }
 .approvalbutton{
    font-family: "Inter" !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 16.94px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    background-color: #FE602F !important;
    color:white !important;
    white-space: nowrap;
    height: 40px !important;
    width:100% !important;
    max-width: 186px !important;
    text-transform: capitalize !important;
    margin-bottom: 3%;
}

.pendingReqMessage{
    font-family: "Inter" !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    color:rgb(217, 33, 33) !important;
    white-space: nowrap !important;
    height: 40px !important;
    width:100% !important;
    max-width: 186px !important;
    text-transform: capitalize !important;
    margin-top: 3%;
    text-align: right;
}

.pendingReqMessageApprove{
    font-family: "Inter" !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    color:rgb(18, 134, 78) !important;
    white-space: nowrap !important;
    height: 40px !important;
    width:100% !important;
    max-width: 186px !important;
    text-transform: capitalize !important;
    margin-top: 3%;
    text-align: right;
}
.rejectbutton{
    font-family: "Inter" !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 16.94px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    background-color: #E90000 !important;
    color:white !important;
    white-space: nowrap;
    height: 40px !important;
    width:100% !important;
    max-width: 186px !important;
    text-transform: capitalize !important;

}

.draftbutton{
    font-family: "Inter" !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 16.94px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    background-color:#0056B2 !important;
    color: #fff !important;
    white-space: nowrap;
    height: 40px !important;
    border: 1px solid #0056B2 !important;
    text-transform: capitalize !important;
}
.copybutton{
    font-family: "Inter" !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 16.94px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    background-color:white !important;
    color: #FE602F !important;
    white-space: nowrap;
    height: 40px !important;
    border: 1px solid #FE602F !important;
    text-transform: capitalize !important;
}
.ReportButton{
    font-family: "Inter" !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 16.94px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    background-color:#E5F0FC !important;
    color: #375370 !important;
    white-space: nowrap;
    height: 42px !important;
    width:100%;
    max-width: 104px;
    text-transform: capitalize !important;
}
.viewhistorybutton{
    font-family: "Inter" !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 16.94px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    background-color:#E5F0FC !important;
    color: #375370 !important;
    white-space: nowrap;
    height: 42px !important;
    text-transform: capitalize !important;
    width:100%;
    max-width: 145px;
 }
 .tick{
    width:44px;
    height:36px;
    align-items: center !important;
    align-self: center;
    align-content: center;
}
.tickcrossgrid{
    align-items: center;
    display: flex;
    gap:20px;
    margin-top: 2%;
    padding-top: 2%;
    margin-left: 2%;
}

input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}

.countBtn{
    height:55px;
    width: 200px;
    margin: 10px;
    background-color: #E5F0FC !important;
    gap: 10px ;
    white-space: nowrap;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    text-transform: capitalize !important;
}



.calBtn{
    font-family: "Inter" !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 16.94px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    height: 40px !important;
    text-transform: capitalize !important;
    align-items: center !important;
    border: 1px solid #fff !important;
}
.calPrevBtn{
    background-color: #008A27 !important;
    color: #fff !important;
    width: 40px !important;
    min-width: auto !important;
    border-radius: 10px 0px 0px 10px !important;
}
.calCurrentBtn{
    background-color: #008A27 !important;
    color: #fff !important;
    width: 120px !important;
    min-width: auto !important;
    border-radius: 0px 0px 0px 0px !important;
}
.calNextBtn{
    background-color: #008A27 !important;
    color: #fff !important;
    width: 40px !important;
    min-width: auto !important;
    border-radius: 0px 10px 10px 0px !important;
}
.dateInput{
    background-color: #008A27 !important;    
}
.dateInput button{
    color: #fff !important;
}
.dateInput input{
    padding: 9px !important;
    width: 100px !important;
    color: #fff !important;
}
.modalInput{
    width: 97% !important;
    padding: 19px 14px !important;
    border: 1px solid #000 !important;
    border-radius: 4px !important;
}
.modalSelect{
    width: 100% !important;
    padding: 16px 14px !important;
    border: 1px solid #000 !important;
    border-radius: 4px !important;
}
.modalTextarea{
    width: 95% !important;
    padding: 16px 14px !important;
    border: 1.5px solid #B2D4F8 !important;
    border-radius: 4px !important;
    
}
.viewValue{
    font-family: "Inter";
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0.02em;
    text-align: justify;
    color:  #0079E9;
    padding-top: 10px;
}




/* new styles */

.projectNameHeadingTable{
    font-family: "Inter";
font-size: 14px;
font-weight: 700;
line-height: 16.94px;
letter-spacing: 0.02em;
text-align: center;
color: #0070E9;
}


.AddTaskButtonInModal{
    width:100% !important;
    max-width: 155px !important;
height:39px !important;
padding: 10px 20px 10px 20px !important;
gap: 10px !important;
border-radius: 3px 0px 0px 0px !important;
/* opacity: 0px !important; */
background-color: #FE602F !important;
color: white !important;
text-transform: none !important;
font-size: 15px !important;
font-weight: 600 !important;
}


.tasklistheadertable{
font-family: "Inter" !important;
font-size: 13px !important;
font-weight: 600 !important;
line-height: 16.94px !important;
letter-spacing: 0.02em !important;
text-align: left !important;
color: #0070E9 !important;

}

/* Timesheet */
.timesheet-main{
    padding: 15px;
}

.timesheet-content1{
    display: flex;
    justify-content:space-between ;
    flex-wrap: wrap;
}

.timesheet-content2{
    padding: 15px 0px;
}
.timesheet-content3{
    padding-top:5px;
    /* padding-bottom: 2%; */
    padding-left: 1%;
}
.MyTimesheetHeading{
    font-family: "Inter";
    font-weight: 700;
    font-size: 19px;
    color: #0079E9;
    /* padding-top: 4px; */

    text-align: left;
   
}
.ConfirmDeletion{
 padding-top: 0px;
    
}

.swal-button-agree {
  background-color: green !important;
  color: white !important;
}

.swal-button-disagree {
  background-color: red !important;
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/views/panel/timesheetnew/Timesheet.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;AACA;IACI;AACJ;AACA;IACI,WAAW;IACX,oCAAoC;IACpC,wBAAwB;IACxB,UAAU;IACV,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;AACzC;AACA;IACI,WAAW;IACX,oCAAoC;IACpC,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;;AAEzC;AACA;IACI,WAAW;IACX,oCAAoC;IACpC,wBAAwB;IACxB,oBAAoB;IACpB,2CAA2C;IAC3C,qCAAqC;AACzC;AACA;IACI,WAAW;IACX,oCAAoC;IACpC,wBAAwB;IACxB,oBAAoB;IACpB,2CAA2C;IAC3C,qCAAqC;AACzC;AACA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb;AACJ;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb;AACJ;AACA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,6BAA6B;IAC7B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,2BAA2B;IAC3B,QAAQ;IACR,qCAAqC;IACrC,mBAAmB;CACtB;CACA;IACG,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,6BAA6B;IAC7B,oCAAoC;IACpC,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,iCAAiC;IACjC,8BAA8B;IAC9B,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,qCAAqC;IACrC,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,iCAAiC;IACjC,8BAA8B;IAC9B,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,qCAAqC;IACrC,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,6BAA6B;IAC7B,oCAAoC;IACpC,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,qCAAqC;;AAEzC;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,6BAA6B;IAC7B,mCAAmC;IACnC,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,qCAAqC;AACzC;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,6BAA6B;IAC7B,iCAAiC;IACjC,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,qCAAqC;AACzC;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,6BAA6B;IAC7B,mCAAmC;IACnC,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,qCAAqC;AACzC;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,6BAA6B;IAC7B,mCAAmC;IACnC,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,UAAU;IACV,gBAAgB;CACnB;CACA;IACG,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,UAAU;IACV,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;AACzC;;;;AAIA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,6BAA6B;IAC7B,uBAAuB;IACvB,qCAAqC;IACrC,8BAA8B;IAC9B,iCAAiC;AACrC;AACA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;IAC1B,2CAA2C;AAC/C;AACA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,yCAAyC;AAC7C;AACA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;IAC1B,2CAA2C;AAC/C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,iCAAiC;IACjC,6BAA6B;AACjC;AACA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,iCAAiC;IACjC,6BAA6B;AACjC;AACA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,sCAAsC;IACtC,6BAA6B;;AAEjC;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;;;;AAKA,eAAe;;AAEf;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,kBAAkB;AAClB,cAAc;AACd;;;AAGA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B,sBAAsB;AACtB,uCAAuC;AACvC,oBAAoB;AACpB,yCAAyC;AACzC,6BAA6B;AAC7B,oCAAoC;AACpC,uBAAuB;AACvB,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B;;;AAGA;AACA,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B,+BAA+B;AAC/B,iCAAiC;AACjC,2BAA2B;AAC3B,yBAAyB;;AAEzB;;AAEA,cAAc;AACd;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,sBAAsB;;IAEtB,gBAAgB;;AAEpB;AACA;CACC,gBAAgB;;AAEjB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB","sourcesContent":[".timesheetcont{\r\n    background-color: white;\r\n    border-radius: 5px;\r\n}\r\n\r\n.tsbods{\r\n    font-family: \"Inter\";\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    line-height: 19.36px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color:#0079E9;\r\n}\r\n.tsheads{\r\n    font-family:\"Inter\";\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color:#002C5D\r\n}\r\n.timesheetbuttontophead{\r\n    background-color: #E5F0FC !important\r\n}\r\n.avlsickleave{\r\n    height:55px;\r\n    background-color: #E5F0FC !important;\r\n    display: flex !important;\r\n    gap: 10px ;\r\n    white-space: nowrap;\r\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n    text-transform: capitalize !important;\r\n}\r\n.avlPTO{\r\n    height:55px;\r\n    background-color: #E5F0FC !important;\r\n    display: flex !important;\r\n    gap: 10px !important;\r\n    white-space: nowrap;\r\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n    text-transform: capitalize !important;\r\n\r\n}\r\n.UTILIZEDSICK{\r\n    height:55px;\r\n    background-color: #E5F0FC !important;\r\n    display: flex !important;\r\n    gap: 10px !important;\r\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n    text-transform: capitalize !important;\r\n}\r\n.utilizedpo{\r\n    height:55px;\r\n    background-color: #E5F0FC !important;\r\n    display: flex !important;\r\n    gap: 10px !important;\r\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n    text-transform: capitalize !important;\r\n}\r\n.buttonleft{\r\n    font-family: \"Inter\";\r\n    font-size: 17px !important;\r\n    font-weight: 700 !important;\r\n    line-height: 19.36px;\r\n    letter-spacing: 0.01em;\r\n    text-align: left;\r\n    color:#0056B2;\r\n    white-space: nowrap\r\n}\r\n.buttonright{\r\n    font-family: \"Inter\";\r\n    font-size: 25px;\r\n    font-weight: 700;\r\n    line-height: 41.15px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color:#0056B2\r\n}\r\n.timesheet-table {\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}  \r\n.timesheet-table th, .timesheet-table td {\r\n    border: 1px solid #E9E9E9;\r\n}\r\n.modalname{\r\n    font-family: \"Inter\";\r\n    font-size: 18px;\r\n    font-weight: 700;\r\n    line-height: 21.78px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color:#0070E9;\r\n    white-space:nowrap\r\n}\r\n.timesheet-input {\r\n    width: 96%;\r\n    height: 50px;\r\n    border: none;\r\n}\r\n.daystyle{\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    text-align: center;\r\n    color:#00162E\r\n}\r\n.projectntaskname{\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    text-align: center;\r\n    color:\"#00162E\";\r\n    padding: 10px;\r\n    /* width:100%; */\r\n    min-width:100px ;\r\n    height: 70px;\r\n}\r\n.datebutton{\r\n    background-color: #008A27 !important;\r\n    font-family: \"Inter\" !important;\r\n    font-size: 14px !important;\r\n    font-weight: 700 !important;\r\n    line-height: 16.94px !important;\r\n    letter-spacing: 0.02em !important;\r\n    text-align: center !important;\r\n    height: 40px !important;\r\n    color:white !important;\r\n    width:100% !important;\r\n    max-width: 157px !important;\r\n    gap:10px;\r\n    text-transform: capitalize !important;\r\n    align-items: center;\r\n }\r\n .approvalbutton{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 14px !important;\r\n    font-weight: 700 !important;\r\n    line-height: 16.94px !important;\r\n    letter-spacing: 0.02em !important;\r\n    text-align: center !important;\r\n    background-color: #FE602F !important;\r\n    color:white !important;\r\n    white-space: nowrap;\r\n    height: 40px !important;\r\n    width:100% !important;\r\n    max-width: 186px !important;\r\n    text-transform: capitalize !important;\r\n    margin-bottom: 3%;\r\n}\r\n\r\n.pendingReqMessage{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 15px !important;\r\n    font-weight: 700 !important;\r\n    color:rgb(217, 33, 33) !important;\r\n    white-space: nowrap !important;\r\n    height: 40px !important;\r\n    width:100% !important;\r\n    max-width: 186px !important;\r\n    text-transform: capitalize !important;\r\n    margin-top: 3%;\r\n    text-align: right;\r\n}\r\n\r\n.pendingReqMessageApprove{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 15px !important;\r\n    font-weight: 700 !important;\r\n    color:rgb(18, 134, 78) !important;\r\n    white-space: nowrap !important;\r\n    height: 40px !important;\r\n    width:100% !important;\r\n    max-width: 186px !important;\r\n    text-transform: capitalize !important;\r\n    margin-top: 3%;\r\n    text-align: right;\r\n}\r\n.rejectbutton{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 14px !important;\r\n    font-weight: 700 !important;\r\n    line-height: 16.94px !important;\r\n    letter-spacing: 0.02em !important;\r\n    text-align: center !important;\r\n    background-color: #E90000 !important;\r\n    color:white !important;\r\n    white-space: nowrap;\r\n    height: 40px !important;\r\n    width:100% !important;\r\n    max-width: 186px !important;\r\n    text-transform: capitalize !important;\r\n\r\n}\r\n\r\n.draftbutton{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 14px !important;\r\n    font-weight: 700 !important;\r\n    line-height: 16.94px !important;\r\n    letter-spacing: 0.02em !important;\r\n    text-align: center !important;\r\n    background-color:#0056B2 !important;\r\n    color: #fff !important;\r\n    white-space: nowrap;\r\n    height: 40px !important;\r\n    border: 1px solid #0056B2 !important;\r\n    text-transform: capitalize !important;\r\n}\r\n.copybutton{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 14px !important;\r\n    font-weight: 700 !important;\r\n    line-height: 16.94px !important;\r\n    letter-spacing: 0.02em !important;\r\n    text-align: center !important;\r\n    background-color:white !important;\r\n    color: #FE602F !important;\r\n    white-space: nowrap;\r\n    height: 40px !important;\r\n    border: 1px solid #FE602F !important;\r\n    text-transform: capitalize !important;\r\n}\r\n.ReportButton{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 14px !important;\r\n    font-weight: 700 !important;\r\n    line-height: 16.94px !important;\r\n    letter-spacing: 0.02em !important;\r\n    text-align: center !important;\r\n    background-color:#E5F0FC !important;\r\n    color: #375370 !important;\r\n    white-space: nowrap;\r\n    height: 42px !important;\r\n    width:100%;\r\n    max-width: 104px;\r\n    text-transform: capitalize !important;\r\n}\r\n.viewhistorybutton{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 14px !important;\r\n    font-weight: 700 !important;\r\n    line-height: 16.94px !important;\r\n    letter-spacing: 0.02em !important;\r\n    text-align: center !important;\r\n    background-color:#E5F0FC !important;\r\n    color: #375370 !important;\r\n    white-space: nowrap;\r\n    height: 42px !important;\r\n    text-transform: capitalize !important;\r\n    width:100%;\r\n    max-width: 145px;\r\n }\r\n .tick{\r\n    width:44px;\r\n    height:36px;\r\n    align-items: center !important;\r\n    align-self: center;\r\n    align-content: center;\r\n}\r\n.tickcrossgrid{\r\n    align-items: center;\r\n    display: flex;\r\n    gap:20px;\r\n    margin-top: 2%;\r\n    padding-top: 2%;\r\n    margin-left: 2%;\r\n}\r\n\r\ninput[type=number]::-webkit-inner-spin-button, \r\ninput[type=number]::-webkit-outer-spin-button { \r\n  -webkit-appearance: none; \r\n  margin: 0; \r\n}\r\n\r\n.countBtn{\r\n    height:55px;\r\n    width: 200px;\r\n    margin: 10px;\r\n    background-color: #E5F0FC !important;\r\n    gap: 10px ;\r\n    white-space: nowrap;\r\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n    text-transform: capitalize !important;\r\n}\r\n\r\n\r\n\r\n.calBtn{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 14px !important;\r\n    font-weight: 700 !important;\r\n    line-height: 16.94px !important;\r\n    letter-spacing: 0.02em !important;\r\n    text-align: center !important;\r\n    height: 40px !important;\r\n    text-transform: capitalize !important;\r\n    align-items: center !important;\r\n    border: 1px solid #fff !important;\r\n}\r\n.calPrevBtn{\r\n    background-color: #008A27 !important;\r\n    color: #fff !important;\r\n    width: 40px !important;\r\n    min-width: auto !important;\r\n    border-radius: 10px 0px 0px 10px !important;\r\n}\r\n.calCurrentBtn{\r\n    background-color: #008A27 !important;\r\n    color: #fff !important;\r\n    width: 120px !important;\r\n    min-width: auto !important;\r\n    border-radius: 0px 0px 0px 0px !important;\r\n}\r\n.calNextBtn{\r\n    background-color: #008A27 !important;\r\n    color: #fff !important;\r\n    width: 40px !important;\r\n    min-width: auto !important;\r\n    border-radius: 0px 10px 10px 0px !important;\r\n}\r\n.dateInput{\r\n    background-color: #008A27 !important;    \r\n}\r\n.dateInput button{\r\n    color: #fff !important;\r\n}\r\n.dateInput input{\r\n    padding: 9px !important;\r\n    width: 100px !important;\r\n    color: #fff !important;\r\n}\r\n.modalInput{\r\n    width: 97% !important;\r\n    padding: 19px 14px !important;\r\n    border: 1px solid #000 !important;\r\n    border-radius: 4px !important;\r\n}\r\n.modalSelect{\r\n    width: 100% !important;\r\n    padding: 16px 14px !important;\r\n    border: 1px solid #000 !important;\r\n    border-radius: 4px !important;\r\n}\r\n.modalTextarea{\r\n    width: 95% !important;\r\n    padding: 16px 14px !important;\r\n    border: 1.5px solid #B2D4F8 !important;\r\n    border-radius: 4px !important;\r\n    \r\n}\r\n.viewValue{\r\n    font-family: \"Inter\";\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    line-height: 19px;\r\n    letter-spacing: 0.02em;\r\n    text-align: justify;\r\n    color:  #0079E9;\r\n    padding-top: 10px;\r\n}\r\n\r\n\r\n\r\n\r\n/* new styles */\r\n\r\n.projectNameHeadingTable{\r\n    font-family: \"Inter\";\r\nfont-size: 14px;\r\nfont-weight: 700;\r\nline-height: 16.94px;\r\nletter-spacing: 0.02em;\r\ntext-align: center;\r\ncolor: #0070E9;\r\n}\r\n\r\n\r\n.AddTaskButtonInModal{\r\n    width:100% !important;\r\n    max-width: 155px !important;\r\nheight:39px !important;\r\npadding: 10px 20px 10px 20px !important;\r\ngap: 10px !important;\r\nborder-radius: 3px 0px 0px 0px !important;\r\n/* opacity: 0px !important; */\r\nbackground-color: #FE602F !important;\r\ncolor: white !important;\r\ntext-transform: none !important;\r\nfont-size: 15px !important;\r\nfont-weight: 600 !important;\r\n}\r\n\r\n\r\n.tasklistheadertable{\r\nfont-family: \"Inter\" !important;\r\nfont-size: 13px !important;\r\nfont-weight: 600 !important;\r\nline-height: 16.94px !important;\r\nletter-spacing: 0.02em !important;\r\ntext-align: left !important;\r\ncolor: #0070E9 !important;\r\n\r\n}\r\n\r\n/* Timesheet */\r\n.timesheet-main{\r\n    padding: 15px;\r\n}\r\n\r\n.timesheet-content1{\r\n    display: flex;\r\n    justify-content:space-between ;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.timesheet-content2{\r\n    padding: 15px 0px;\r\n}\r\n.timesheet-content3{\r\n    padding-top:5px;\r\n    /* padding-bottom: 2%; */\r\n    padding-left: 1%;\r\n}\r\n.MyTimesheetHeading{\r\n    font-family: \"Inter\";\r\n    font-weight: 700;\r\n    font-size: 19px;\r\n    color: #0079E9;\r\n    /* padding-top: 4px; */\r\n\r\n    text-align: left;\r\n   \r\n}\r\n.ConfirmDeletion{\r\n padding-top: 0px;\r\n    \r\n}\r\n\r\n.swal-button-agree {\r\n  background-color: green !important;\r\n  color: white !important;\r\n}\r\n\r\n.swal-button-disagree {\r\n  background-color: red !important;\r\n  color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
